export default __webpack_public_path__ + "a2579001086bea9f371b8f031ab854af.png";